<template>
  <component :is="tag" class="bim-container" :id="id" :class="{'bim-container--fluid': fluid}">
    <!-- @slot Безымянный слот. Используется для добавление сюда содержимого -->
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: 'bimContainer',
  props: {
    /**
     * Делает контейнер шириной 100% на всех размерах
     */
    fluid: Boolean,
    /**
     * Добавляет контейнеру id
     */
    id: String,
    /**
     * Какой тег будет у контейнера
     */
    tag: {
      type: String,
      default: 'div'
    }
  }
}
</script>

<style lang="scss" scoped>
  .bim-container {
    width : 100%;
    box-sizing: border-box;
    margin: 0 auto;
    max-width: $breakpoint-xxl;
    padding: 0 $gap-xxl;

    @media screen and (min-width: $breakpoint-xl) and (max-width: $breakpoint-xxl) {
      max-width: $breakpoint-xl;
      padding: 0 $gap-xl;
    }
    @media screen and (min-width: $breakpoint-lg) and (max-width: $breakpoint-xl) {
      max-width: $breakpoint-lg;
      padding: 0 $gap-lg;
    }
    @media screen and (min-width: $breakpoint-md) and (max-width: $breakpoint-lg) {
      max-width: $breakpoint-md;
      padding: 0 $gap-md;
    }
    @media screen and (min-width: $breakpoint-sm) and (max-width: $breakpoint-md) {
      max-width: $breakpoint-sm;
      padding: 0 $gap-sm;
    }
    @media screen and (min-width: $breakpoint-xs) and (max-width: $breakpoint-sm) {
      max-width: 100%;
      padding: 0 $gap-xs;
    }
    .bim-container {
      padding: 0;
    }

    &--fluid {
      max-width: 100%;
    }
  }
</style>
